export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute();
  const { gtag } = useGtag();
  const trackedClicks = new Set<string>();

  const trackEmailClick = () => {
    const campaignId = route.query.email_campaign_id;
    const emailLogId = route.query.email_log_id;

    if (typeof campaignId !== 'string' || typeof emailLogId !== 'string') return;

    const eventKey = `${campaignId}:${emailLogId}`;
    if (trackedClicks.has(eventKey)) return;
    trackedClicks.add(eventKey);

    const eventParams = {
      campaign_id: campaignId,
      email_log_id: emailLogId,
      destination: window.location.pathname,
    };

    if (import.meta.dev) {
      console.info('[gtag] email_link_click event triggered', eventParams);
    }

    gtag('event', 'email_link_click', eventParams);

    // Keep the recipient-specific identifiers out of the address bar and future referrers.
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('email_campaign_id');
    cleanUrl.searchParams.delete('email_log_id');
    window.history.replaceState(window.history.state, '', cleanUrl.toString());
  };

  nuxtApp.hook('app:mounted', trackEmailClick);
  nuxtApp.hook('page:finish', trackEmailClick);
});
